module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-pagination",
    style: (_vm.screenExercise ? 'display: block;' : '')
  }, [_c('div', {
    staticClass: "pagination-show",
    style: (_vm.screenExercise ? 'padding-right: 0px; text-align: center; font-size: 12px; padding-bottom: 8px;' : '')
  }, [_vm._v(_vm._s(_vm.showPagination()))]), _c('div', {
    staticClass: "pagination-page"
  }, [(!_vm.noLiSurround) ? _c('ul', {
    staticClass: "pagination-custom"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('a', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        return _vm.selectFirstPage()
      }
    }
  }, [_vm._v("first_page")])]), (!(_vm.firstPageSelected() && _vm.hidePrevNext)) ? _c('li', {
    staticClass: "pagination-item",
    class: [_vm.prevClass, _vm.firstPageSelected() ? _vm.disabledClass : '']
  }, [_c('a', {
    staticClass: "material-icons",
    class: _vm.prevLinkClass,
    attrs: {
      "tabindex": _vm.firstPageSelected() ? -1 : 0
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_vm._v("chevron_left")])]) : _vm._e(), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item",
      class: [_vm.pageClass, page.selected ? _vm.activeClass : '', page.disabled ? _vm.disabledClass : '', page.breakView ? _vm.breakViewClass : '']
    }, [(page.breakView) ? _c('a', {
      staticClass: "page-link",
      class: [_vm.pageLinkClass, _vm.breakViewLinkClass]
    }, [_vm._t("breakViewContent", [_vm._v(_vm._s(_vm.breakViewText))])], 2) : (page.disabled) ? _c('a', {
      staticClass: "page-link",
      class: _vm.pageLinkClass
    }, [_vm._v(_vm._s(page.content))]) : _c('a', {
      staticClass: "page-link",
      class: _vm.pageLinkClass,
      on: {
        "click": function($event) {
          return _vm.handlePageSelected(page.index + 1)
        }
      }
    }, [_vm._v(_vm._s(page.content))])])
  }), (!(_vm.lastPageSelected() && _vm.hidePrevNext)) ? _c('li', {
    staticClass: "pagination-item",
    class: [_vm.nextClass, _vm.lastPageSelected() ? _vm.disabledClass : '']
  }, [_c('a', {
    staticClass: "material-icons",
    class: _vm.nextLinkClass,
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_vm._v("chevron_right")])]) : _vm._e(), _c('li', {
    staticClass: "pagination-item"
  }, [_c('a', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        return _vm.selectLastPage()
      }
    }
  }, [_vm._v("last_page")])])], 2) : _c('div', {
    class: _vm.containerClass
  }, [(_vm.firstLastButton) ? _c('a', {
    class: [_vm.pageLinkClass, _vm.firstPageSelected() ? _vm.disabledClass : ''],
    on: {
      "click": function($event) {
        return _vm.selectFirstPage()
      }
    }
  }) : _vm._e(), (!(_vm.firstPageSelected() && _vm.hidePrevNext)) ? _c('a', {
    class: [_vm.prevLinkClass, _vm.firstPageSelected() ? _vm.disabledClass : ''],
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }) : _vm._e(), _vm._l((_vm.pages), function(page) {
    return [(page.breakView) ? _c('a', {
      class: [_vm.pageLinkClass, _vm.breakViewLinkClass, page.disabled ? _vm.disabledClass : '']
    }, [_vm._t("breakViewContent", [_vm._v(_vm._s(_vm.breakViewText))])], 2) : (page.disabled) ? _c('a', {
      class: [_vm.pageLinkClass, page.selected ? _vm.activeClass : '', _vm.disabledClass]
    }, [_vm._v(_vm._s(page.content))]) : _c('a', {
      class: [_vm.pageLinkClass, page.selected ? _vm.activeClass : ''],
      on: {
        "click": function($event) {
          return _vm.handlePageSelected(page.index + 1)
        }
      }
    }, [_vm._v(_vm._s(page.content))])]
  }), (!(_vm.lastPageSelected() && _vm.hidePrevNext)) ? _c('a', {
    class: [_vm.nextLinkClass, _vm.lastPageSelected() ? _vm.disabledClass : ''],
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }) : _vm._e(), (_vm.firstLastButton) ? _c('a', {
    class: [_vm.pageLinkClass, _vm.lastPageSelected() ? _vm.disabledClass : ''],
    on: {
      "click": function($event) {
        return _vm.selectLastPage()
      }
    }
  }) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5595229e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/Pagination/index.vue
// module id = 1567
// module chunks = 0